import {
  authApiService,
} from '@/services/auth-api-service';
import {
  RefreshTokenTransformer,
} from '@/transformers/auth/RefreshTokenTransformer';
import {
  AxiosTransformedValue,
} from '@/transformers/types';
import {
  AxiosServicePromiseFactory,
} from '@/utils/axios-service-promise-factory';

export class AuthAdaptor {
  public static refreshToken(refreshToken: string): Promise<AxiosTransformedValue> {
    return AxiosServicePromiseFactory.getPromise(
      authApiService,
      'refreshToken',
      refreshToken,
      RefreshTokenTransformer,
    );
  }
}
